import { useMutation } from '@tanstack/react-query';
import type {
  UpdateCryptoAddressRequestDto,
  UpdateCryptoAddressResponseDto,
} from '../../model';
import { updateCryptoAddress } from '../requests';

interface Options {
  onSuccess?: (data: UpdateCryptoAddressResponseDto) => void;
  onError?: (error: Error) => void;
}

type UpdateCryptoAddressVariables = {
  networkName: string;
  templateId: string;
  data: UpdateCryptoAddressRequestDto;
};

export function useUpdateCryptoAddress({ onSuccess, onError }: Options) {
  const mutation = useMutation<
    UpdateCryptoAddressResponseDto,
    Error,
    UpdateCryptoAddressVariables
  >({
    mutationFn: ({ networkName, templateId, data }) =>
      updateCryptoAddress(templateId, networkName, data),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
